var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, PropSync, Emit, } from 'vue-property-decorator';
import Modal from 'components/Modal.vue';
let CorrectionCompanyDataModal = class CorrectionCompanyDataModal extends Vue {
    constructor() {
        super(...arguments);
        this.showConfirm = false;
        this.showEditData = false;
        this.cnpj = '';
        this.websiteUrl = '';
        this.linkedinUrl = '';
    }
    clearStates() {
        this.open = false;
        this.showConfirm = false;
        this.showEditData = false;
        this.cnpj = '';
        this.websiteUrl = '';
        this.linkedinUrl = '';
    }
    cnpjMask(cnpj) {
        return cnpj
            .replace(/\D/g, '')
            .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    get canShowConfirmModal() {
        return this.showConfirm && (this.websiteUrl != '' || this.linkedinUrl != '');
    }
    get calculateHeight() {
        return this.showCompanyResume && !this.showEditData
            ? 390
            : this.showCompanyResume && this.showEditData
                ? 840
                : 280;
    }
    searchCompany() {
        const cnpj = this.cnpj.replace(/[^0-9]/g, '');
        return cnpj;
    }
    updateCompanyLinkedinOrWebsite() {
        this.showConfirm = false;
        return {
            cnpj: this.companyData.cnpj,
            websiteUrl: this.websiteUrl,
            linkedinUrl: this.linkedinUrl,
        };
    }
    updateCompany() {
        return this.companyData.cnpj;
    }
};
__decorate([
    PropSync('show', { default: false })
], CorrectionCompanyDataModal.prototype, "open", void 0);
__decorate([
    Prop({ default: false })
], CorrectionCompanyDataModal.prototype, "loadinSearchCompany", void 0);
__decorate([
    Prop({ default: false })
], CorrectionCompanyDataModal.prototype, "showCompanyResume", void 0);
__decorate([
    Prop({ default: false })
], CorrectionCompanyDataModal.prototype, "searchCompanyLoading", void 0);
__decorate([
    Prop({ default: false })
], CorrectionCompanyDataModal.prototype, "updateCompanyLoading", void 0);
__decorate([
    Prop({ default: false })
], CorrectionCompanyDataModal.prototype, "updateCompanyLinkedinOrWebsiteLoading", void 0);
__decorate([
    Prop({ default: () => { } })
], CorrectionCompanyDataModal.prototype, "companyData", void 0);
__decorate([
    Emit('clearStates')
], CorrectionCompanyDataModal.prototype, "clearStates", null);
__decorate([
    Emit('searchCompany')
], CorrectionCompanyDataModal.prototype, "searchCompany", null);
__decorate([
    Emit('updateCompanyLinkedinOrWebsite')
], CorrectionCompanyDataModal.prototype, "updateCompanyLinkedinOrWebsite", null);
__decorate([
    Emit('updateCompany')
], CorrectionCompanyDataModal.prototype, "updateCompany", null);
CorrectionCompanyDataModal = __decorate([
    Component({
        name: 'CorrectionCompanyDataModal',
        components: {
            Modal,
        },
    })
], CorrectionCompanyDataModal);
export default CorrectionCompanyDataModal;
